// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1p93L","footer":"ReportModalFilter_footer__3XOlG"};